import { Component, Input, OnInit } from '@angular/core';
import { NovedadSolicitudDTO } from 'src/app/infraestructure/interfaces/referente/NovedadSolicitudDTO';

@Component({
  selector: 'app-table-news-request',
  templateUrl: './table-news-request.component.html',
  styleUrls: ['./table-news-request.component.scss']
})
export class TableNewsRequestComponent implements OnInit {

  @Input() dataTable: NovedadSolicitudDTO[] = [];

  constructor() { }

  ngOnInit(): void {
  }

}
